import { Component, Input } from '@angular/core';

@Component({
    selector: 'nova-custom-field-grid-viewer-table',
    templateUrl: './custom-field-grid-viewer-table.component.html',
    styleUrls: ['./custom-field-grid-viewer-table.component.scss']
})
export class CustomFieldGridViewerTableComponent {
    @Input() values = [];
    @Input() isLoading = true;
    displayedColumns: string[] = ['name', 'value'];

    constructor() {}
}
